/**
 * Token saving service
 */
import { Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage/local-storage.service';

const DEFAULT_TOKEN_LOCAL_STORAGE_KEY = 'accessToken';

@Injectable()
export class TokenSessionService {
  public constructor(private storage: LocalStorageService) {}

  public saveToken(token, key = DEFAULT_TOKEN_LOCAL_STORAGE_KEY): any {
    return this.storage.setItem(key, token.token);
  }

  public getToken(key = DEFAULT_TOKEN_LOCAL_STORAGE_KEY): string {
    return this.storage.getItem(key);
  }

  public removeToken(key = DEFAULT_TOKEN_LOCAL_STORAGE_KEY): void {
    this.storage.removeItem(key);
  }

  public createTokenInIframeMode(token): object {
    return {
      token,
      user: JSON.parse(atob(token.split('.')[1])),
    };
  }
}
